import styles from './Chip.module.css';

export interface ChipProps {
  /** The key the answer was picked with. */
  shortcut?: string;
  /** A small picture in place of the key, for an answer that was typed, like their company's logo. */
  icon?: string | null;
  label: string;
  onClick?: () => void;
  /** Names the chip within its row, so the row can slide it aside when another answer joins. */
  labelId?: string;
}

/** An answer already given, kept in view at the top of the screen. Pressing it goes back to that question. */
export function Chip({ shortcut, icon, label, onClick, labelId }: ChipProps) {
  return (
    <button type="button" className={styles.chip} onClick={onClick} disabled={!onClick} data-glide={labelId}>
      {icon ? <img className={styles.icon} src={icon} alt="" /> : shortcut ? <span className={styles.key}>{shortcut}</span> : null}
      <span>{label}</span>
    </button>
  );
}
